import menuApi from '@/api/menu'
import staffApi from '@/api/staff'
import Url from '@/utils/Url'
import Menu from '@/utils/Menu'

const state = {
  menus: [],
  pageName: '',
  businessId: '',
  businessName: '',
  officeId: null,
  ceremonyStatus: '',
  staff: { name: '', email: '' },
  enforcementStartDateTime: '',
  usageLimitFlag: false,
  usageLimitDays: null,
  navbar: null,
  root: null,
  hasMailButton: false,
  exclusiveControl: false,
  loading: false
}

const getters = {
  menus: state => state.menus.map(m => new Menu(m)),
  root: state => state.root ? new Url(state.root) : '',
  getMenuName: state => functionCode => {
    for (let menu of state.menus) {
      if (menu.menu_url.href.function_code === functionCode) {
        return menu.menu_name
      }
    }
    return ''
  },
  getEnforcementStartDateTime: state => state.enforcementStartDateTime
  ? state.enforcementStartDateTime : '',
  getUsageLimitFlag: state => state.usageLimitFlag
  ? state.usageLimitFlag : false,
  getUsageLimitDays: state => state.usageLimitDays
  ? state.usageLimitDays : 0,
}

const mutations = {
  SET_MENUS(state, payload) {
    state.menus = payload
  },
  SET_PAGE_NAME(state, payload) {
    state.pageName = payload
  },
  SET_ROOT(state, payload) {
    state.root = payload
  },
  SET_BUSINESS_ID(state, payload) {
    state.businessId = payload
  },
  SET_BUSINESS_NAME(state, payload) {
    state.businessName = payload
  },
  SET_OFFICE_ID(state, payload) {
    state.officeId = payload
  },
  SET_CEREMONY_STATUS(state, payload) {
    state.ceremonyStatus = payload
  },
  SET_STAFF(state, payload) {
    state.staff = payload
  },
  SET_NAVBAR(state, payload) {
    state.navbar = payload
  },
  SET_HAS_MAIL_BUTTON(state, payload) {
    state.hasMailButton = payload
  },
  SET_ENFORCEMENT_START_DATE_TIME(state, payload) {
    state.enforcementStartDateTime = payload
  },
  SET_USAGE_LIMIT_FLAG(state, payload) {
    state.usageLimitFlag = payload
  },
  SET_USAGE_LIMIT_DAYS(state, payload) {
    state.usageLimitDays = payload
  },
  SET_EXCLUSIVE_CONTROL(state, payload) {
    state.exclusiveControl = payload
  },
  START_LOADING(state) {
    state.loading = true
  },
  END_LOADING(state) {
    state.loading = false
  }
}

const actions = {
  async fetchMenu({ commit }, businessId) {
    const response = await menuApi.get(businessId)
    const {
      menu,
      business_name,
      office_id,
      mail_button_display,
      login_page,
      enforcement_start_date_time,
      usage_limit_flag,
      usage_limit_days,
      ceremony_status,
    } = response

    commit('SET_MENUS', menu)
    commit('SET_BUSINESS_NAME', business_name)
    commit('SET_OFFICE_ID', office_id)
    commit('SET_HAS_MAIL_BUTTON', mail_button_display)
    commit('SET_ROOT', login_page)
    commit('SET_ENFORCEMENT_START_DATE_TIME', enforcement_start_date_time)
    commit('SET_USAGE_LIMIT_FLAG', usage_limit_flag)
    commit('SET_USAGE_LIMIT_DAYS', usage_limit_days)
    commit('SET_CEREMONY_STATUS', ceremony_status)
  },
  async fetchStaff({ commit, rootGetters }, businessId) {
    // 施設ユーザーは担当者を取得しない
    if (rootGetters['auth/isFacility']) {
      return false
    }

    const response = await staffApi.get(businessId)
    const { staff_name: name, staff_email: email } = response
    commit('SET_STAFF', { name, email })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
